import { Environment } from './environment-type';

export const environment: Environment = {
    production: false,
    configFile: 'assets/config/config.test.json'
};
